import React from 'react';
import types from './types';
import UIEditorSubcomponent from '../UIEditorSubcomponent';
import Scenario from '../../../classes/scenarioElements/Scenario';
import store, { StoreActions } from '../../../state/store';

export default function UINextStep(props)
{
	const properties = {
		visible: {
			type: 'toggle',
			typeoverride: 'toggle-icon',
			default: true,
		}
	}

	if(props.getProperties)
	{
		return properties;
	}

	if (props.context === 'editor')
	{
		return (
			<UIEditorSubcomponent
				title={'Next Step'}
				subcomponent={types.NEXT_STEP}
				properties={properties}
				{...props}
			/>
		);
	}
	else if (props.data.visible.value)
	{
		return (
			<div className={"uiButtonStep next"}
				data-name='ui-preview-next-step'
			>
				<img alt="next"
					src='./svg/next.svg'
					onClick={(e) =>
					{
						let nextStep;

						if(store.getState().uiModule.nextStepOverride)
						{
							nextStep = Scenario.getStep(store.getState().uiModule.nextStepOverride);
							store.dispatch(StoreActions.ui.setNextStepOverride(""));
						}
						else
						{
							nextStep = Scenario.currentStep().getNextStep();
						}
						
						if (nextStep)
						{
							Scenario.setCurrentStep(nextStep);
						}
					}}
				/>
			</div>
		);
	}

	return null;
}